import React, { useEffect, useState } from 'react';
import { getSingleWidgetDetail } from "../../../../staticWidgets/utils/CommonWidgetApi";
import { getTemplateDetail, getDefaultList } from "../../../../utils/fileEmbedApi";

const CommonTemplate = ({ selectedTemplate, selectedLayout, isTemplateId, widgetId, pdfEmbedTabData,refreshWidgetList }) => {
    const [apiData, setApiData] = useState(false);
    const [isLoading, setIsLoading] = useState(true); 

    // Default values for the pdfEmbedTabData
    const {
        is_website_frontend,
        width,
        widget_title,
        is_show_file_icon,
        file_icon_type,
        widget_title_color,
        name_color,
        icon_color,
        background_color,
        download_link_color,
        file_background_color,
        name_size,
        download_size,
        layout_type,
        preview_image_width,
        is_show_download_link,
        download_link_text,
        height_width_ratio
    } = pdfEmbedTabData || {};

    // Call Css
    useEffect(() => {
        // Remove other module CSS
        const oldLinks = document.querySelectorAll('link[data-dynamic-css]');
        oldLinks.forEach(link => link.remove());

        // Load CSS
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = `${process.env.PUBLIC_URL}/pdf-embed/temp-css/PdfEmbed.css`;
        if (widgetId) {
            link.setAttribute("pdf-embed-data-dynamic-css", "pdf-embed");
        } else {
            link.setAttribute("data-dynamic-css", "pdf-embed");
        }
        document.head.appendChild(link);

        // Clean up on unmount
        return () => {
            const thisLink = document.querySelector('link[data-dynamic-css="pdf-embed"]');
            if (thisLink) thisLink.remove();
        };
    }, [widgetId]);


    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);

                if (isTemplateId) {
                    const result = await getTemplateDetail(isTemplateId);
                    setApiData(result);
                } else if (widgetId) {
                    const result = await getSingleWidgetDetail(widgetId);
                    setApiData(result);
                } else {
                    let module_type = 'Pdf_Embed';
                    let template_type = selectedTemplate;
                    const result = await getDefaultList(module_type,template_type);
                    setApiData(result);
                }
            } catch (error) {
                // console.error("Error fetching data:", error);
                setApiData(null);
            } finally {
                setIsLoading(false); 
            }
        };

        // Only run when any of these change
        if (isTemplateId !== undefined || widgetId !== undefined || selectedTemplate !== undefined) {
            fetchData();
        }
    }, [isTemplateId, widgetId, selectedTemplate, refreshWidgetList]);

    //New Width 
    let new_max_width;
    if (!width) {
        new_max_width = "100%"; 
    } else if (/^\d+$/.test(width)) {
        new_max_width = `${width}px`;
    } else {
        new_max_width = width;
    }

    return (
        <>
            <div className={`upgadeify-pdf-embed-template-main ${is_website_frontend} ${layout_type}`} style={{ backgroundColor: background_color, maxWidth: new_max_width, marginInline: "auto", padding: background_color ? "20px" : ''}}>
               <div className="upgadeify-pdf-embed-template">
                {isLoading ? (
                    <div className="loader-container">
                        <div className="spinner"></div>
                        <p>Loading please wait...</p>
                    </div>
                ) : (
                    <>
                        {layout_type === "file-viewer" && (
                            <>
                            {apiData?.data?.data_list ? (
                                <div className="upgadeify-pdf-template">
                                    <Header widget_title_color={widget_title_color} widget_title={widget_title} />
                                    <div className="upgadeify-pdf-template">
                                        {apiData.data.data_list.map((item) => (
                                            <LoopItem 
                                                key={item.id} 
                                                item={item}
                                                is_show_file_icon={is_show_file_icon}
                                                file_icon_type={file_icon_type}
                                                icon_color={icon_color}
                                                file_background_color={file_background_color}
                                                preview_image_width={preview_image_width}
                                                name_color={name_color}
                                                name_size={name_size}
                                                is_show_download_link={is_show_download_link}
                                                download_link_color={download_link_color}
                                                download_size={download_size}
                                                download_link_text={download_link_text}
                                                layout_type={layout_type}
                                                height_width_ratio={height_width_ratio}
                                                width={width}/>
                                        ))}
                                    </div>
                                </div>
                                ) : (
                                    <div className="loader-container">
                                        <div className="spinner"></div>
                                        <p>Loading please wait...</p>
                                    </div>
                                )}
                            </>
                        )}

                        {layout_type === "grid" && (
                            <>  
                            {apiData?.data?.data_list ? (
                                <div className="upgadeify-pdf-template-grid">
                                    <Header widget_title_color={widget_title_color} widget_title={widget_title} />
                                    <div className="upgadeify-pdf-template">
                                        {apiData.data.data_list.map((item) => (
                                            <LoopItem 
                                                key={item.id} 
                                                item={item}
                                                is_show_file_icon={is_show_file_icon}
                                                file_icon_type={file_icon_type}
                                                icon_color={icon_color}
                                                file_background_color={file_background_color}
                                                preview_image_width={preview_image_width}
                                                name_color={name_color}
                                                name_size={name_size}
                                                is_show_download_link={is_show_download_link}
                                                download_link_color={download_link_color}
                                                download_size={download_size}
                                                download_link_text={download_link_text}
                                                layout_type={layout_type}
                                                height_width_ratio={height_width_ratio}
                                                width={width}/>
                                        ))}
                                    </div>
                                </div>
                                ) : (
                                    <div className="loader-container">
                                        <div className="spinner"></div>
                                        <p>Loading please wait...</p>
                                    </div>
                                )}
                            </>
                        )}

                        {layout_type === "list" && (
                            <>  
                            {apiData?.data?.data_list ? (
                                <div className="upgadeify-pdf-template-list">
                                    <Header widget_title_color={widget_title_color} widget_title={widget_title} />
                                    <div className="upgadeify-pdf-template">
                                        {apiData.data.data_list.map((item) => (
                                            <LoopItem 
                                                key={item.id} 
                                                item={item}
                                                is_show_file_icon={is_show_file_icon}
                                                file_icon_type={file_icon_type}
                                                icon_color={icon_color}
                                                file_background_color={file_background_color}
                                                preview_image_width={preview_image_width}
                                                name_color={name_color}
                                                name_size={name_size}
                                                is_show_download_link={is_show_download_link}
                                                download_link_color={download_link_color}
                                                download_size={download_size}
                                                download_link_text={download_link_text}
                                                layout_type={layout_type}
                                                height_width_ratio={height_width_ratio}
                                                width={width}/>
                                        ))}
                                    </div>
                                </div>
                                ) : (
                                    <div className="loader-container">
                                        <div className="spinner"></div>
                                        <p>Loading please wait...</p>
                                    </div>
                                )}
                            </>
                        )}
                    </>
                )}
               </div>
            </div>
        </>
    );
};

const Header = ({widget_title_color,widget_title}) => (
    <><div className="upgadeify-pdf-widget-title" style={{ color: widget_title_color }}>{widget_title}</div></>
);

const LoopItem = (props) => {
    // destructure props
    const {
        item,
        is_show_file_icon,
        file_icon_type,
        icon_color,
        file_background_color,
        preview_image_width,
        name_color,
        name_size,
        is_show_download_link,
        download_link_color,
        download_size,
        download_link_text,
        layout_type,
        width,
        height_width_ratio
    } = props;

    //File Icon Type
    const FileIconType = (fileType, iconColor) => {
        if (fileType === 'icon-1') {
            return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 38" width="30px" height="38px" fill={iconColor}><path d="M3 0h18.757a3 3 0 0 1 2.122.879L29.12 6.12A3 3 0 0 1 30 8.243V35a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3Zm5.264 32.777V31.23h1.28c.57 0 1.043-.098 1.419-.299.378-.202.656-.466.826-.794.165-.316.247-.658.247-1.022a2.18 2.18 0 0 0-.247-1.023c-.17-.327-.448-.592-.826-.794-.376-.2-.85-.298-1.42-.298H7.628a.63.63 0 0 0-.628.636v5.141c0 .172.062.326.182.446s.274.182.446.182a.63.63 0 0 0 .636-.628Zm1.204-2.77H8.264v-1.785h1.204c.513 0 .857.094 1.034.26.182.171.27.377.27.633a.823.823 0 0 1-.27.632c-.177.167-.52.26-1.034.26Zm4.196 3.356h1.688c.684 0 1.272-.153 1.76-.463a2.981 2.981 0 0 0 1.093-1.195 3.373 3.373 0 0 0 0-3.046 2.981 2.981 0 0 0-1.093-1.196c-.488-.31-1.076-.463-1.76-.463h-1.688a.63.63 0 0 0-.628.636v5.1c0 .171.062.325.182.445s.274.182.446.182Zm1.596-1.214h-.96v-3.935h.96c.42 0 .782.084 1.09.251.307.166.542.393.709.686.168.294.253.636.253 1.03 0 .395-.085.738-.253 1.032-.167.292-.402.52-.708.685-.31.167-.672.251-1.091.251Zm5.572.628v-1.993h2.337a.606.606 0 0 0 .43-.17.585.585 0 0 0 .181-.432.598.598 0 0 0-.178-.433.598.598 0 0 0-.433-.179h-2.337v-1.356h2.631a.606.606 0 0 0 .43-.17.585.585 0 0 0 .181-.433.598.598 0 0 0-.178-.433.598.598 0 0 0-.433-.178h-3.267a.63.63 0 0 0-.628.636v5.141c0 .172.062.326.182.446s.273.182.446.182a.63.63 0 0 0 .636-.628Zm2.045-17.764c-.27-.512-.93-.763-2.013-.763-.636 0-1.418.081-2.33.243-1.272-1.323-2.592-3.254-3.53-5.153.147-.609.286-1.226.392-1.842.122-.723.269-1.55.114-2.28-.065-.293-.236-.553-.432-.772-.171-.186-.407-.446-.685-.446a3.61 3.61 0 0 0-.7.113c-.4.13-.611.439-.783.828-.489 1.128.18 3.043.872 4.529a45.58 45.58 0 0 1-2.624 7.328c-2.624 1.185-4.017 2.345-4.147 3.457-.05.406.048.998.774 1.526.195.146.431.219.668.219.603 0 1.222-.455 1.931-1.437.514-.714 1.076-1.687 1.655-2.897a33.874 33.874 0 0 1 6.12-1.923c1.091 1.03 2.077 1.558 2.917 1.558.62 0 1.149-.284 1.54-.812.4-.551.489-1.046.26-1.476ZM8.469 20.847c-.326-.243-.301-.405-.301-.47.04-.382.643-1.055 2.126-1.867-1.116 2.037-1.719 2.305-1.825 2.337Zm5.688-15.622c.033-.008.725.747.066 2.191-.987-.99-.14-2.166-.066-2.19ZM12.723 16.15c.7-1.648 1.36-3.466 1.85-5.154.774 1.372 1.711 2.71 2.648 3.782-1.475.333-3.047.82-4.498 1.372Zm8.94-.325c-.212.292-.677.3-.84.3-.366 0-.505-.219-1.076-.64.465-.057.905-.074 1.255-.074.62 0 .734.09.815.138-.008.04-.049.13-.155.276Z"></path></svg>
        } else if (fileType === 'icon-2') {
            return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 38"  width="30px" height="38px" fill={iconColor}>
                <path d="M4 2a2 2 0 0 0-2 2v30a2 2 0 0 0 2 2h22a2 2 0 0 0 2-2V9.243a2 2 0 0 0-.586-1.415l-5.242-5.242A2 2 0 0 0 20.757 2H4Zm0-2h16.757a4 4 0 0 1 2.829 1.172l5.242 5.242A4 4 0 0 1 30 9.243V34a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4Zm18.877 16.013c.228.43.138.925-.261 1.476-.391.528-.92.812-1.54.812-.84 0-1.826-.528-2.918-1.558a33.874 33.874 0 0 0-6.12 1.923c-.578 1.21-1.14 2.183-1.654 2.897C9.675 22.545 9.056 23 8.453 23c-.237 0-.473-.073-.668-.22-.726-.527-.823-1.119-.774-1.525.13-1.112 1.523-2.272 4.147-3.457a45.58 45.58 0 0 0 2.624-7.328c-.692-1.486-1.36-3.4-.872-4.529.172-.39.383-.698.783-.828a3.61 3.61 0 0 1 .7-.113c.278 0 .514.26.685.446.196.22.367.479.432.771.155.73.008 1.558-.114 2.28a28.456 28.456 0 0 1-.391 1.843c.937 1.899 2.257 3.83 3.528 5.153.913-.162 1.695-.243 2.331-.243 1.084 0 1.744.251 2.013.763ZM8.469 21.847c.106-.032.71-.3 1.825-2.337-1.483.812-2.086 1.485-2.126 1.867 0 .065-.025.227.301.47Zm5.688-15.622c-.073.025-.92 1.201.066 2.191.66-1.444-.033-2.199-.066-2.19ZM12.723 17.15a34.027 34.027 0 0 1 4.498-1.372c-.937-1.071-1.874-2.41-2.648-3.782a46.899 46.899 0 0 1-1.85 5.154Zm8.1-.025c.163 0 .628-.008.84-.3.105-.146.146-.235.154-.276-.081-.049-.195-.138-.815-.138-.35 0-.79.017-1.255.073.57.422.71.641 1.076.641ZM8.264 32.777a.63.63 0 0 1-.636.628.615.615 0 0 1-.446-.182.615.615 0 0 1-.182-.446v-5.14A.63.63 0 0 1 7.628 27h1.915c.57 0 1.044.098 1.42.298.378.202.656.467.826.794.165.316.247.658.247 1.023 0 .364-.082.706-.247 1.022-.17.328-.448.592-.826.794-.376.2-.85.299-1.42.299H8.264v1.547Zm1.204-2.77c.513 0 .857-.093 1.034-.26a.823.823 0 0 0 .27-.632.823.823 0 0 0-.27-.633c-.177-.166-.52-.26-1.034-.26H8.264v1.785h1.204Zm4.196 3.356a.615.615 0 0 1-.446-.182.615.615 0 0 1-.182-.446v-5.099a.63.63 0 0 1 .628-.636h1.688c.684 0 1.272.154 1.76.463.483.307.849.706 1.093 1.196a3.373 3.373 0 0 1 0 3.046c-.244.489-.61.888-1.093 1.195-.488.31-1.076.463-1.76.463h-1.688Zm1.596-1.214c.42 0 .782-.084 1.09-.251a1.76 1.76 0 0 0 .709-.685 2.04 2.04 0 0 0 .253-1.031c0-.395-.085-.737-.253-1.031a1.757 1.757 0 0 0-.708-.686c-.31-.167-.672-.251-1.091-.251h-.96v3.935h.96Zm5.572.628a.63.63 0 0 1-.636.628.615.615 0 0 1-.446-.182.615.615 0 0 1-.182-.446v-5.14a.63.63 0 0 1 .628-.637h3.267c.167 0 .316.061.433.178a.598.598 0 0 1 .178.433.585.585 0 0 1-.181.433.606.606 0 0 1-.43.17h-2.631v1.356h2.337c.167 0 .316.061.433.179a.598.598 0 0 1 .178.433.585.585 0 0 1-.181.432.606.606 0 0 1-.43.17h-2.337v1.993Z"></path></svg>
        } else if (fileType === 'icon-3') {
            return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 38" width="30px" height="38px" fill={iconColor}><path d="M3 0h18.757a3 3 0 0 1 2.122.879L29.12 6.12A3 3 0 0 1 30 8.243V35a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3Zm5.264 22.777V21.23h1.28c.57 0 1.043-.098 1.419-.299.378-.202.656-.466.826-.794.165-.316.247-.658.247-1.022a2.18 2.18 0 0 0-.247-1.023c-.17-.327-.448-.592-.826-.794-.376-.2-.85-.298-1.42-.298H7.628a.63.63 0 0 0-.628.636v5.141c0 .172.062.326.182.446s.274.182.446.182a.63.63 0 0 0 .636-.628Zm1.204-2.77H8.264v-1.785h1.204c.513 0 .857.094 1.034.26.182.171.27.377.27.633a.823.823 0 0 1-.27.632c-.177.167-.52.26-1.034.26Zm4.196 3.356h1.688c.684 0 1.272-.153 1.76-.463a2.981 2.981 0 0 0 1.093-1.195 3.373 3.373 0 0 0 0-3.046 2.981 2.981 0 0 0-1.093-1.196c-.488-.31-1.076-.463-1.76-.463h-1.688a.63.63 0 0 0-.628.636v5.1c0 .171.062.325.182.445s.274.182.446.182Zm1.596-1.214h-.96v-3.935h.96c.42 0 .782.084 1.09.251.307.166.542.393.709.686.168.294.253.636.253 1.03 0 .395-.085.738-.253 1.032-.167.292-.402.52-.708.685-.31.167-.672.251-1.091.251Zm5.572.628v-1.993h2.337a.606.606 0 0 0 .43-.17.585.585 0 0 0 .181-.432.598.598 0 0 0-.178-.433.598.598 0 0 0-.433-.179h-2.337v-1.356h2.631a.606.606 0 0 0 .43-.17.585.585 0 0 0 .181-.433.598.598 0 0 0-.178-.433.598.598 0 0 0-.433-.178h-3.267a.63.63 0 0 0-.628.636v5.141c0 .172.062.326.182.446s.273.182.446.182a.63.63 0 0 0 .636-.628Z"></path></svg>
        } else if (fileType === 'icon-4') {
            return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 38"  width="30px" height="38px" fill={iconColor}><path d="M4 2a2 2 0 0 0-2 2v30a2 2 0 0 0 2 2h22a2 2 0 0 0 2-2V9.243a2 2 0 0 0-.586-1.415l-5.242-5.242A2 2 0 0 0 20.757 2H4Zm0-2h16.757a4 4 0 0 1 2.829 1.172l5.242 5.242A4 4 0 0 1 30 9.243V34a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4Zm4.264 22.777a.63.63 0 0 1-.636.628.615.615 0 0 1-.446-.182.615.615 0 0 1-.182-.446v-5.14A.63.63 0 0 1 7.628 17h1.915c.57 0 1.044.098 1.42.298.378.202.656.467.826.794.165.316.247.658.247 1.023 0 .364-.082.706-.247 1.022-.17.328-.448.592-.826.794-.376.2-.85.299-1.42.299H8.264v1.547Zm1.204-2.77c.513 0 .857-.093 1.034-.26a.823.823 0 0 0 .27-.632.823.823 0 0 0-.27-.633c-.177-.166-.52-.26-1.034-.26H8.264v1.785h1.204Zm4.196 3.356a.615.615 0 0 1-.446-.182.615.615 0 0 1-.182-.446v-5.099a.63.63 0 0 1 .628-.636h1.688c.684 0 1.272.154 1.76.463.483.307.849.706 1.093 1.196a3.373 3.373 0 0 1 0 3.046c-.244.489-.61.888-1.093 1.195-.488.31-1.076.463-1.76.463h-1.688Zm1.596-1.214c.42 0 .782-.084 1.09-.251a1.76 1.76 0 0 0 .709-.685 2.04 2.04 0 0 0 .253-1.031c0-.395-.085-.737-.253-1.031a1.757 1.757 0 0 0-.708-.686c-.31-.167-.672-.251-1.091-.251h-.96v3.935h.96Zm5.572.628a.63.63 0 0 1-.636.628.615.615 0 0 1-.446-.182.615.615 0 0 1-.182-.446v-5.14a.63.63 0 0 1 .628-.637h3.267c.167 0 .316.061.433.178a.598.598 0 0 1 .178.433.585.585 0 0 1-.181.433.606.606 0 0 1-.43.17h-2.631v1.356h2.337c.167 0 .316.061.433.179a.598.598 0 0 1 .178.433.585.585 0 0 1-.181.432.606.606 0 0 1-.43.17h-2.337v1.993Z"></path></svg>
        } else if (fileType === 'icon-5') {
            return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 38" width="30px" height="38px" fill={iconColor}><path d="M3 0h18.757a3 3 0 0 1 2.122.879L29.12 6.12A3 3 0 0 1 30 8.243V35a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3Zm21.846 21.46c-.336-.625-1.162-.932-2.516-.932-.795 0-1.773.099-2.913.297-1.59-1.617-3.24-3.977-4.411-6.298a34.73 34.73 0 0 0 .489-2.252c.153-.883.336-1.894.142-2.787-.08-.357-.295-.675-.54-.942-.213-.229-.509-.546-.855-.546-.184 0-.683.08-.876.139-.5.159-.764.536-.978 1.011-.611 1.38.224 3.72 1.09 5.535-.744 2.827-1.976 6.21-3.28 8.957-3.28 1.448-5.022 2.866-5.185 4.225-.061.496.061 1.22.968 1.865.244.178.54.268.835.268.754 0 1.528-.556 2.414-1.756.642-.872 1.345-2.063 2.068-3.54 2.323-.973 5.185-1.856 7.65-2.352 1.365 1.26 2.597 1.905 3.647 1.905.774 0 1.436-.347 1.925-.992.499-.675.611-1.28.326-1.805Zm-18.01 7.13c-.407-.297-.376-.496-.376-.575.05-.466.804-1.29 2.658-2.281-1.395 2.49-2.149 2.817-2.282 2.856Zm7.11-19.093c.041-.01.907.912.082 2.678-1.233-1.21-.173-2.649-.081-2.678Zm-1.792 13.35a56.49 56.49 0 0 0 2.312-6.298c.968 1.676 2.139 3.313 3.31 4.622a43.255 43.255 0 0 0-5.622 1.676Zm11.174-.396c-.265.357-.845.367-1.049.367-.458 0-.632-.268-1.345-.784.581-.07 1.131-.09 1.57-.09.773 0 .916.11 1.018.17-.01.05-.062.158-.194.337Z"></path></svg>
        } else if (fileType === 'icon-6') {
            return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 38" width="30px" height="38px" fill={iconColor}><path d="M4 2a2 2 0 0 0-2 2v30a2 2 0 0 0 2 2h22a2 2 0 0 0 2-2V9.243a2 2 0 0 0-.586-1.415l-5.242-5.242A2 2 0 0 0 20.757 2H4Zm0-2h16.757a4 4 0 0 1 2.829 1.172l5.242 5.242A4 4 0 0 1 30 9.243V34a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4Zm20.846 21.46c.285.526.173 1.13-.326 1.805-.489.645-1.151.992-1.925.992-1.05 0-2.282-.645-3.647-1.905-2.465.496-5.327 1.379-7.65 2.351-.723 1.478-1.426 2.669-2.068 3.541C8.344 29.444 7.57 30 6.816 30c-.295 0-.59-.09-.835-.268-.907-.645-1.029-1.369-.968-1.865.163-1.359 1.905-2.777 5.185-4.225 1.304-2.748 2.536-6.13 3.28-8.957-.866-1.815-1.701-4.156-1.09-5.535.214-.475.479-.852.978-1.011.193-.06.692-.139.876-.139.346 0 .642.317.856.546.244.267.458.585.54.942.193.893.01 1.904-.143 2.787a34.108 34.108 0 0 1-.49 2.252c1.172 2.32 2.822 4.681 4.412 6.298 1.14-.198 2.118-.297 2.913-.297 1.354 0 2.18.307 2.516.932Zm-18.01 7.13c.133-.04.887-.367 2.282-2.856-1.854.992-2.607 1.815-2.658 2.281 0 .08-.031.278.376.575Zm7.11-19.093c-.091.03-1.15 1.468.082 2.678.825-1.766-.04-2.688-.081-2.678Zm-1.792 13.35a43.255 43.255 0 0 1 5.622-1.676c-1.171-1.31-2.342-2.946-3.31-4.622a56.49 56.49 0 0 1-2.312 6.298Zm11.174-.396c.132-.179.183-.288.194-.337-.102-.06-.245-.17-1.019-.17-.438 0-.988.02-1.569.09.713.516.887.784 1.345.784.204 0 .784-.01 1.049-.367Z"></path></svg>
        } else { 
            return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 38" width="30px" height="38px" fill={iconColor}><path d="M3 0h18.757a3 3 0 0 1 2.122.879L29.12 6.12A3 3 0 0 1 30 8.243V35a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3Zm5.264 32.777V31.23h1.28c.57 0 1.043-.098 1.419-.299.378-.202.656-.466.826-.794.165-.316.247-.658.247-1.022a2.18 2.18 0 0 0-.247-1.023c-.17-.327-.448-.592-.826-.794-.376-.2-.85-.298-1.42-.298H7.628a.63.63 0 0 0-.628.636v5.141c0 .172.062.326.182.446s.274.182.446.182a.63.63 0 0 0 .636-.628Zm1.204-2.77H8.264v-1.785h1.204c.513 0 .857.094 1.034.26.182.171.27.377.27.633a.823.823 0 0 1-.27.632c-.177.167-.52.26-1.034.26Zm4.196 3.356h1.688c.684 0 1.272-.153 1.76-.463a2.981 2.981 0 0 0 1.093-1.195 3.373 3.373 0 0 0 0-3.046 2.981 2.981 0 0 0-1.093-1.196c-.488-.31-1.076-.463-1.76-.463h-1.688a.63.63 0 0 0-.628.636v5.1c0 .171.062.325.182.445s.274.182.446.182Zm1.596-1.214h-.96v-3.935h.96c.42 0 .782.084 1.09.251.307.166.542.393.709.686.168.294.253.636.253 1.03 0 .395-.085.738-.253 1.032-.167.292-.402.52-.708.685-.31.167-.672.251-1.091.251Zm5.572.628v-1.993h2.337a.606.606 0 0 0 .43-.17.585.585 0 0 0 .181-.432.598.598 0 0 0-.178-.433.598.598 0 0 0-.433-.179h-2.337v-1.356h2.631a.606.606 0 0 0 .43-.17.585.585 0 0 0 .181-.433.598.598 0 0 0-.178-.433.598.598 0 0 0-.433-.178h-3.267a.63.63 0 0 0-.628.636v5.141c0 .172.062.326.182.446s.273.182.446.182a.63.63 0 0 0 .636-.628Zm2.045-17.764c-.27-.512-.93-.763-2.013-.763-.636 0-1.418.081-2.33.243-1.272-1.323-2.592-3.254-3.53-5.153.147-.609.286-1.226.392-1.842.122-.723.269-1.55.114-2.28-.065-.293-.236-.553-.432-.772-.171-.186-.407-.446-.685-.446a3.61 3.61 0 0 0-.7.113c-.4.13-.611.439-.783.828-.489 1.128.18 3.043.872 4.529a45.58 45.58 0 0 1-2.624 7.328c-2.624 1.185-4.017 2.345-4.147 3.457-.05.406.048.998.774 1.526.195.146.431.219.668.219.603 0 1.222-.455 1.931-1.437.514-.714 1.076-1.687 1.655-2.897a33.874 33.874 0 0 1 6.12-1.923c1.091 1.03 2.077 1.558 2.917 1.558.62 0 1.149-.284 1.54-.812.4-.551.489-1.046.26-1.476ZM8.469 20.847c-.326-.243-.301-.405-.301-.47.04-.382.643-1.055 2.126-1.867-1.116 2.037-1.719 2.305-1.825 2.337Zm5.688-15.622c.033-.008.725.747.066 2.191-.987-.99-.14-2.166-.066-2.19ZM12.723 16.15c.7-1.648 1.36-3.466 1.85-5.154.774 1.372 1.711 2.71 2.648 3.782-1.475.333-3.047.82-4.498 1.372Zm8.94-.325c-.212.292-.677.3-.84.3-.366 0-.505-.219-1.076-.64.465-.057.905-.074 1.255-.074.62 0 .734.09.815.138-.008.04-.049.13-.155.276Z"></path></svg>
        }
    };

    const preview_image_height = Number(preview_image_width) + 20;

    const [headerWidth, setHeaderWidth] = useState("100%");
    const calculateHeaderWidth = () => {
        const screenWidth = window.innerWidth;

        // Convert width prop to number if exists
        const numericMaxWidth =
            typeof width === "string" ? parseInt(width.replace("px", ""), 10) : width;

        // Take the smaller of screen width or max width
        const effectiveWidth = numericMaxWidth ? Math.min(screenWidth, numericMaxWidth) : screenWidth;

        if (layout_type === "grid") {
            if (effectiveWidth < 500) return "100%";
            if (effectiveWidth < 700) return "50%";
            if (effectiveWidth < 856) return "33.33%";
            return "25%";
        }

        return "100%";
    };

    useEffect(() => {
        const handleResize = () => setHeaderWidth(calculateHeaderWidth());

        handleResize(); // initial width
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, [layout_type, width]);

    //Frame ratio setup 
    const ratio = height_width_ratio || 16 / 9;
    let iframeWidth;

    if (!width) {
        iframeWidth = 800;
    } else if (typeof width === "number") {
        iframeWidth = width;
    } else if (typeof width === "string") {
        if (width.endsWith("px")) {
            iframeWidth = parseInt(width, 10);
        } else if (width.endsWith("%")) {
            iframeWidth = 800; 
        } else {
            iframeWidth = parseInt(width, 10) || 800;
        }
    }
    // Inverted calculation
    const iframeHeight = Math.round((1000 / iframeWidth) * ratio * 100);

    return (
       <>
        <div className="upgadeify-pdf-template_header" style={{ width: headerWidth }}>
             <div className='upgadeify-pdf-template_header_inner' style={{ backgroundColor: file_background_color, padding: file_background_color ? "15px" : '' }}>
            <div className="upgadeify-pdf-template_header_image">
                {Number(is_show_file_icon) === 1 ? (
                    item.image ? (
                        <img src={item.image} alt={item.alt_text} style={{width: preview_image_width+'px', height:preview_image_height+'px',objectFit: 'contain'}}/>
                    ) : (
                        FileIconType(file_icon_type, icon_color)
                    )
                    ) : (
                    item.image && (
                        <img src={item.image} alt={item.alt_text} style={{width: preview_image_width+'px', height:preview_image_height+'px',objectFit: 'contain'}}/>
                    )
                )}
                <div className="upgadeify-pdf-template_filename" style={{ color: name_color, fontSize: name_size }}>{item.name }</div>
            </div>
            {Number(is_show_download_link) === 1 && (
                <div className="upgadeify-pdf-template_header_download">
                    <button
                        onClick={() => window.open(item.file_name, '_blank')}
                        className="upgadeify-pdf-template_header_download_link"
                        style={{ color: download_link_color, fontSize: download_size }}
                        >
                        {download_link_text}
                    </button>
                </div>
            )}
        </div>
        </div>
  
        <div>
            {/*only of file-viewer layout*/}
            {layout_type === "file-viewer" && (
                <div className="upgadeify-pdf-template-iframe">
                    <iframe src={item.file_name} title={`PDF Viewer - ${item.name}`} width="100%" height={iframeHeight} style={{ border: "1px solid #ccc", marginTop: "10px" }}/>
                </div>
            )}
        </div>
       </>
    );
};

export default CommonTemplate;
